import React, { createContext, useContext, useState, useCallback } from 'react';

const CrosswalkContext = createContext();

export const useCrosswalk = () => useContext(CrosswalkContext);

export const CrosswalkProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [minimized, setMinimized] = useState(false);
  const [crosswalkJobs, setCrosswalkJobs] = useState([]);
  const [hasActiveJobs, setHasActiveJobs] = useState(false);
  const [crosswalkCompleted, setCrosswalkCompleted] = useState(false);

  // Start crosswalk silently in background — no modal popup
  const startInBackground = useCallback((jobs) => {
    setCrosswalkJobs(jobs);
    setHasActiveJobs(true);
    setCrosswalkCompleted(false);
    setIsOpen(false);
    setMinimized(false);
  }, []);

  // Open (or restore from minimized) — always unminimizes
  const openCrosswalkModal = useCallback(() => {
    if (crosswalkJobs.length > 0) {
      setIsOpen(true);
      setMinimized(false);
    }
  }, [crosswalkJobs.length]);

  const minimizeCrosswalk = useCallback(() => setMinimized(true), []);
  const restoreCrosswalk = useCallback(() => setMinimized(false), []);

  // allDone=true → clear everything; false → keep jobs so toolbar button stays
  const closeCrosswalkModal = useCallback((allDone = false) => {
    setIsOpen(false);
    setMinimized(false);
    if (allDone) {
      setCrosswalkJobs([]);
      setHasActiveJobs(false);
      setCrosswalkCompleted(false);
    }
  }, []);

  const markCrosswalkDone = useCallback(() => {
    setCrosswalkCompleted(true);
  }, []);

  return (
    <CrosswalkContext.Provider value={{
      isOpen, minimized, crosswalkJobs, hasActiveJobs, crosswalkCompleted,
      startInBackground, openCrosswalkModal, markCrosswalkDone,
      minimizeCrosswalk, restoreCrosswalk, closeCrosswalkModal
    }}>
      {children}
    </CrosswalkContext.Provider>
  );
};
